module.exports = __webpack_public_path__ + "static/Labcontrol-206709288c18b7116970dff955149cca.mp4";